const images = {
    logo: require("../assets/images/caasLogo.png"),
    sidebarlogo: require("../assets/images/sidebarlogo.png"),
    avatar: require("../assets/images/avatar.png"),
    loader: require("../assets/images/loader.gif"),
    bio: require("../assets/images/bio.png"),
}
export default images;